<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-form ref="dailyCheckForm" id="dailyCheckForm" v-model="valid" lazy-validation>
                <v-toolbar flat>
                    <v-toolbar-title>Daily Check</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-spacer />
                </v-toolbar>
                <div class="mt-3">
                    <v-row class="mx-5">
                        <v-col lg="2" md="3" sm="4" cols="4">Date</v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">
                            <v-menu v-model="dateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto" :disabled="true">
                                <template v-slot:activator="{ on, attrs}">
                                    <v-text-field v-model="date" prepend-inner-icon="mdi-calendar" disabled readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form" :rules="reqRule"></v-text-field>
                                </template>
                                <v-date-picker v-model="date" @change="setDate"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col lg="2" md="3" sm="4" cols="4">Volume</v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">
                            <v-select outlined dense hide-details="auto" :items="volumes" item-value="code" item-text="description" v-model="volume" @change="changeVolume">
                            </v-select>
                        </v-col>
                        <v-col lg="4">
                            <v-btn depressed color="primary" @click="getIsellerData" :loading="isellerProgress" :disabled="isellerProgress">
                                Get Iseller Data
                            </v-btn>
                            <v-btn depressed color="primary" class="ms-2" @click="refreshData">
                                Refresh Data
                            </v-btn>
                            <v-btn depressed color="green" class="ms-2 white--text" @click="export2xls">
                                Export to XLS
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5">
                        <v-col lg="2" md="3" sm="4" cols="4">Last Update Iseller</v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">{{ lastUpdateIseller }}</v-col>
                    </v-row>
                    <section class="view">
                        <v-card class="table-container" style="max-height: 440px;">
                            <v-simple-table class="spreadsheet-table flex-table" fixed-header ref="tabelExport">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="header-cell">Volume</th>
                                            <th class="header-cell">Outlet</th>
                                            <th class="header-cell text-center">Saldo Awal</th>
                                            <th class="header-cell text-center">IN</th>
                                            <th class="header-cell text-center">OUT</th>
                                            <th class="header-cell text-center">Total Opening</th>
                                            <th class="header-cell text-center">Estimasi Closing</th>
                                            <th class="header-cell text-center">Sisa</th>
                                            <th class="header-cell text-center">Stock In Besok</th>
                                            <th class="header-cell text-center">Total Opening <br/> {{ nextDate }}</th>
                                            <th class="header-cell text-center">(%)</th>
                                            <th class="header-cell text-center">Terjual</th>
                                            <th class="header-cell text-center">Pesanan</th>
                                            <th class="header-cell text-center">Sisa</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="isLoading">
                                            <tr v-for="n in 15" :key="n">
                                                <th><v-skeleton-loader type="text" /></th>
                                                <th><v-skeleton-loader type="text" /></th>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                                <td><v-skeleton-loader type="text" /></td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr v-for="(row, idx) in calculatedItems" :key="idx">
                                                <th class="header-cell">{{ row.volume }}ml</th>
                                                <th class="header-cell">{{ row.name }}</th>
                                                <td class="spreadsheet-cell text-center">{{ items[idx].opening }}</td>
                                                <td class="spreadsheet-cell text-center">{{ row.stock_in }}</td>
                                                <td class="spreadsheet-cell text-center">{{ row.transfer_out }}</td>
                                                <td class="spreadsheet-cell text-center">{{ row.total_opening }}</td>
                                                <td class="spreadsheet-cell text-center">{{ row.estimasi_closing }}</td>
                                                <td class="spreadsheet-cell text-center">{{ row.sisa }}</td>
                                                <td class="spreadsheet-cell">
                                                    <v-text-field v-model="items[idx].stock_in_tommorow" class="spreadsheet-input" type="number" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" />
                                                    <span style="display: none;">{{ items[idx].stock_in_tommorow }}</span>
                                                </td>
                                                <td class="spreadsheet-cell text-center">{{ row.total_opening_tommorow }}</td>
                                                <td class="spreadsheet-cell text-center">{{ row.percent_sold }}</td>
                                                <td class="spreadsheet-cell text-center">{{ row.sales_actual }}</td>
                                                <td class="spreadsheet-cell">
                                                    <v-text-field v-model="items[idx].order" class="spreadsheet-input" type="number" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" />
                                                    <span style="display: none;">{{ items[idx].order }}</span>
                                                </td>
                                                <td class="spreadsheet-cell text-center">{{ row.sisa2 }}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </section>
                </div>
                <v-card-actions class="pr-4 mt-3 mx-5">
                    <v-btn depressed color="error" @click="showFormIseller">
                        Nightly Update
                    </v-btn>
                    <v-spacer />
                    <v-btn depressed color="primary" @click="saveData" class="px-6">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <v-overlay :value="saveProgress" z-index="999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-dialog v-model="dialogIseller" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Nightly Update</span>
                </v-card-title>
                <v-divider />
                <v-card-text>
                    <v-container>
                        <v-form ref="formIseller" v-model="validIseller" lazy-validation>
                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <span>Dari</span>
                                    <v-menu v-model="dateMenuIseller" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="iseller_date" filled dense hide-details="auto" :rules="reqRule" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="iseller_date" @input="dateMenuIseller = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <span>Sampai</span>
                                    <v-menu v-model="dateMenuIseller2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="iseller_date2" filled dense hide-details="auto" :rules="reqRule" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="iseller_date2" @input="dateMenuIseller2 = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <span>Volume</span>
                                    <v-select outlined dense hide-details="auto" :items="volumes" item-value="code" item-text="description" v-model="iseller_volume">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-card-text>
                        <v-container>
                            <!-- ...existing form... -->
                            <div v-if="isellerProgressNightly && isellerProcessingDate" class="mt-2">
                                <v-alert type="info" dense text>
                                    Memproses tanggal: <b>{{ isellerProcessingDate }}</b>
                                </v-alert>
                            </div>
                        </v-container>
                    </v-card-text>                    
                    <v-spacer />
                    <v-btn color="blue darken-1" text @click="closeIseller">
                        Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="getIsellerDataNightly"  :loading="isellerProgressNightly" :disabled="isellerProgressNightly">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { utils, writeFileXLSX } from 'xlsx';

export default {
    data() {
        return {
            date: '',
            nextDate: '',
            valid: true,
            saveProgress: false,
            isellerProgress: false,
            isellerProgressNightly: false,
            isLoading: false,
            dateMenu: false,
            volume: '',
            volumes: [],
            items: [],
            itemsIseller: [],
            reqRule: [v => !!v || 'Harus diisi!'],
            numberRule: val => {
                if (val < 0) return 'Tidak boleh kurang dari 0'
                return true
            },
            dialogIseller: false,
            validIseller: true,
            dateMenuIseller: false,
            iseller_date: '',
            iseller_date2: '',
            dateMenuIseller2: false,
            iseller_volume: '490',
            isellerProcessingDate: '',
        }
    },
    computed: {
        calculatedItems() {
            return this.items.map(item => ({
                ...item,
                stock_in: this.calculateStockIn(item),
                total_opening: this.calculateTotalOpening(item),
                estimasi_closing: this.calculateEstimasiClosing(item),  
                sisa: this.calculateSisa(item),
                total_opening_tommorow: this.calculateTotalOpeningTommorow(item),
                sales_actual: this.calculateSalesActual(item),
                sisa2: this.calculateSisa2(item),
            }))
        },
        lastUpdateIseller() {
            if (this.items.length === 0) return '';
            
            return this.items[0].last_update_iseller;
        }
    },
    async created() {
        // this.date = moment().format('YYYY-MM-DD');

        this.getVolumes();
        this.fetchDailyCheck();
    },
    methods: {
        setDate() {
            this.fetchDailyCheck();
        },
        setDateIseller() {

        },
        getVolumes() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.volumes = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });

            let firstVolume = this.volumes.slice(0, 1)[0];
            this.volume = firstVolume.code;
        },
        changeVolume() {
            this.fetchDailyCheck();
        },
        async fetchDailyCheck() {
            try {
                this.isLoading = true

                const response = (await this.$store.dispatch('dailycheck/getObjs', {date: this.date, volume: this.volume}))

                this.date = response.data.data.date;
                this.nextDate = response.data.data.next_date;
                this.items = response.data.data.items;

                this.iseller_date = response.data.data.date;

            } catch (error) {
                console.log('Error loading data:', error)
            } finally {
                this.isLoading = false
            }
        },
        calculateStockIn(row) {
            const stockIn = parseInt(row.stock_in);
            const transferIn = parseInt(row.transfer_in);

            return stockIn + transferIn;
        },
        calculateTotalOpening(row) {
            const opening = parseInt(row.opening);
            const stockIn = this.calculateStockIn(row);
            const stockOut = parseInt(row.transfer_out);

            return opening + stockIn - stockOut;
        },
        calculateEstimasiClosing(row) {
            const salesActual = this.calculateSalesActual(row);
            const percent_sold = Number(row.percent_sold);
            const pesanan = Number(row.order);

            if (!row || typeof percent_sold !== 'number' || percent_sold <= 0 || percent_sold >= 100) {
                return 0;
            }
            
            const percentSisa = 100 - percent_sold;

            const result = salesActual + Math.round(salesActual * (percentSisa/100) / (percent_sold/100)) + pesanan;
            return result;
        },
        calculateSisa(row) {
            return this.calculateTotalOpening(row) - this.calculateEstimasiClosing(row);
        },
        calculateTotalOpeningTommorow(row) {
            return this.calculateSisa(row) + parseInt(row.stock_in_tommorow);
        },
        calculateSalesActual(row) {
            return parseInt(row.sales_actual) - parseInt(row.order);
        },
        calculateSisa2(row) {

            if (!row || typeof Number(row.percent_sold) !== 'number' || row.percent_sold <= 0 || row.percent_sold >= 100) {
                return 0;
            }
            
            const percent_sisa = 100 - Number(row.percent_sold);
            
            return Math.round(this.calculateSalesActual(row) * (percent_sisa / 100) / (row.percent_sold / 100));
        },
        async saveData() {
            await this.$refs.dailyCheckForm.validate();

            if (!this.valid) return;

            this.saveProgress = true;

            try {
                const saveItems = this.calculatedItems.map((item) => {
                    return {
                        'code': item.code,
                        'volume': item.volume,
                        'sales_date': item.sales_date,
                        'stock_in_tommorow': item.stock_in_tommorow,
                        'order': item.order,
                        'sales_planning': item.estimasi_closing,
                    };
                })

                const result = await this.$store.dispatch('dailycheck/store', {
                    items: saveItems
                });

                if (result.status == 200 || result.status == 201) {
                    this.saved = true
                    this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Data berhasil diupdate'})
                    this.fetchDailyCheck();
                
                } else {
                    this.saveError = true
                }

                this.saveProgress = false
            } catch (error) {
                console.error('Error save daily check :', error);
            } finally {
                this.saveProgress = false;
            }
        },
        async getIsellerData() {
            this.isellerProgress = true;

            try {
                const result = await this.$store.dispatch('dailycheck/storeIseller', {
                    date: this.date,
                    volume: this.volume,
                });

                if (result.status == 200) {
                    await this.fetchDailyCheck();
                    this.saved = true;
                    this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Iseller data berhasil di ambil'});
                } else {
                    this.saveError = true
                }
            } catch (error) {
                console.error('Error save iseller data :', error);
            } finally {
                this.isellerProgress = false;
            }
        },
        async getIsellerDataNightly() {
            this.isellerProgressNightly = true;
            this.saveError = false;
            this.isellerProcessingDate = '';

            const startDate = new Date(this.iseller_date);
            const endDate = new Date(this.iseller_date2);
            const daysDiff = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));

            try {
                for (let dayOffset = 0; dayOffset <= daysDiff; dayOffset++) {
                    const currentDate = new Date(startDate.getTime() + dayOffset * 24 * 60 * 60 * 1000);
                    const dateStr = currentDate.toISOString().slice(0, 10);
                    this.isellerProcessingDate = dateStr;

                    let success = false;
                    let retries = 0;
                    const maxRetries = 3;

                    while (!success && retries < maxRetries) {
                        try {
                            const result = await this.$store.dispatch('dailycheck/storeIseller', {
                                date: dateStr,
                                volume: this.iseller_volume,
                                nightly: true,
                            });

                            if (result.status === 200) {
                                success = true;
                            } else {
                                retries++;
                                if (retries >= maxRetries) {
                                    this.saveError = true;
                                    break;
                                }
                            }
                        } catch (error) {
                            retries++;
                            if (retries >= maxRetries) {
                                this.saveError = true;
                                break;
                            }
                        }
                    }

                    if (this.saveError) break;
                }

                await this.fetchDailyCheck();
                this.saved = true;
                this.dialogIseller = false;
                this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Iseller data berhasil di ambil'});
            } catch (error) {
                console.error('Error save iseller data :', error);
                this.saveError = true;
            } finally {
                this.isellerProgressNightly = false;
                this.isellerProcessingDate = '';
            }
        },
        refreshData() {
            this.fetchDailyCheck();
        },
        showFormIseller() {
            this.dialogIseller = true;
        },
        closeIseller() {
            this.dialogIseller = false;
        },
        export2xls() {
            const wb = utils.table_to_book(this.$refs.tabelExport.$el.firstChild.firstChild);
            let fileName = 'DailyCheck.xlsx';

            writeFileXLSX(wb, fileName);
        }
    }
}
</script>

<style scoped>
.no-padding-table td {
    padding: 0 !important;
    margin: 0 !important;
}
td .v-text-field {
    width: 100%;
}

.spreadsheet-table {
  border-collapse: collapse;
  width: 100%;
}

.header-cell,
.spreadsheet-cell {
  border: 1px solid #ddd;
  padding: 8px !important;
  text-align: left;
  min-width: 100px;
}

.spreadsheet-cell {
  background-color: #f9f9f9;
  cursor: pointer;
  padding: 0px !important;
}

.spreadsheet-cell:focus-within {
  background-color: #e6f7ff;
  outline: none;
}

.spreadsheet-input {
  padding: 0 !important;
  margin: 0;
  border: none;
  box-shadow: none;
  /* background-color: transparent !important; */
  background-color: yellow !important;
  font-size: inherit;
  width: 100%;
}

.spreadsheet-input input {
  padding: 0 !important;
  border: none;
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__slot {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control input {
  background-color: #ffe169 !important;
  text-align: center;
}

.compact-input {
  font-size: 0.8rem;
  padding: 0 !important;
  margin: 0 !important;
}

.compact-input .v-input__control {
  min-height: 36px !important; /* Adjust to make it more compact */
}

.compact-input .v-label {
  font-size: 0.7rem !important;
}

.compact-input .v-input__slot {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.view {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}

.table-container {
  display: flex;
  margin-top: 20px;
  flex-grow: 1;
  overflow: hidden;
}

.flex-table {
  display: flex;
  flex-grow: 1;
  width: 100%;
}

.flex-table > div {
  width: 100%;
}
</style>